<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-show="adminShow">
        <el-select v-model="queryParams.userId" filterable clearable placeholder="代理商" @change="search">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="msisdn" >
        <el-input v-model="queryParams.msisdn" placeholder="MSISDN" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="userId" label="代理商" align="center" v-show="adminShow"></el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="content" label="短信内容" align="center"></el-table-column>
      <el-table-column prop="createTime" label="接收时间" align="center"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import {agentList, simSmsReceivedList} from "@/api/api.js";
export default {
  data(){
    return {
      queryParams:{
        msisdn:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      // 日期范围
      dateRange: [],
      agentList: [],
    }
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods:{
    // 获取列表信息
    initData() {
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      simSmsReceivedList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery(){
      this.dateRange = [];
      this.resetForm("queryForm");
      this.initData()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
  },
  created(){
    if(this.adminShow){
      this.queryAgentList();
    }
    this.initData();
  },
  mounted(){

  }
}
</script>
